import {drilldownDistributionLoader} from '../../../../util/dataLoader';
import {withTimeout} from '../../../../util/http/withTimeout';
import {IDistributionComponentAPIResponse} from './distributionComponentSlice';

export const getDistribution = (filters): Promise<IDistributionComponentAPIResponse> => {
  const controller = new AbortController();
  return withTimeout(
    drilldownDistributionLoader.get(filters, controller) as Promise<IDistributionComponentAPIResponse>,
    controller
  );
}
